export function industriesSlider() {
	let industriesSlider = $(".industries-slider");
	let industriesNav = $(".industries-nav");
	let navListLength = industriesNav.find(".item").length;
	industriesNav.slick({
		infinite: false,
		slidesToShow: 1.01,
		slidesToScroll: 1,
		asNavFor: industriesSlider,
		focusOnSelect: true,
		mobileFirst: true,
		prevArrow: '<button class="slick-arrow slick-prev"><i>Previous Slide</i><svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'<path d="M22 7.05668H3.93463L6.80084 10.0101L5.35232 11.5L0 6L5.35232 0.5L6.80084 1.98991L3.93463 4.94332H22V7.05668Z" fill="white"/>\n' +
			'</svg></button>',
		nextArrow: '<button class="slick-arrow slick-next"><i>Next Slide</i><svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
			'<path d="M0 6.55668H18.0654L15.1992 9.51009L16.6477 11L22 5.5L16.6477 0L15.1992 1.48991L18.0654 4.44332H0V6.55668Z" fill="white"/>\n' +
			'</svg></button>',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 1799,
				settings: {
					slidesToShow: 4
				}
			}
		]
	});

	$(window).on("resize", function () {
		if (window.innerWidth >= 1024 && navListLength <= 4) {
			industriesSlider.slick('slickGoTo', 0);
			industriesNav.slick('slickGoTo', 0);
		}
	});
	$(".slick-prev").addClass("disabled");
	industriesNav.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		if (currentSlide === navListLength - 1) {
			$(".slick-next").addClass("disabled");
		} else {
			$(".slick-next").removeClass("disabled");
		}
		if (currentSlide === 0) {
			$(".slick-prev").addClass("disabled");
		} else {
			$(".slick-prev").removeClass("disabled");
		}
	});

	industriesSlider.slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: industriesNav,
		adaptiveHeight: true
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/industriesSlider.js